export const mutations = {
  setLastProducts(state, payload) {
    state.lastProducts = payload;
  },
  setRecentlyAccessedCollection(state, payload) {
    state.recentlyAccessedCollection = payload;
  },
};
